import { render } from "./DynamicSidebar.vue?vue&type=template&id=172b6f92&scoped=true"
import script from "./DynamicSidebar.vue?vue&type=script&lang=js"
export * from "./DynamicSidebar.vue?vue&type=script&lang=js"

import "./DynamicSidebar.vue?vue&type=style&index=0&id=172b6f92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172b6f92"]])

export default __exports__